import RewardScarcity from "@Enums/RewardScarcity";
import RewardTypes from "@Enums/RewardTypes";
import { Box } from "@mui/material";
import { BybListItemBackgroundColorGradient } from "@Shared/mappings/rewardsMappings";
import { useState } from "react";
import BybRewardDrawer from "../drawers/byb-reward-drawer";
import BybRewardListItemCompact from "./byb-reward-list-item-compact";
import BybRewardListItemRegular from "./byb-reward-list-item-regular";

interface IBybRewardListItem {
  id: number;
  name: string;
  goal?: string | null;
  type: RewardTypes;
  scarcity?: RewardScarcity;
  color?: BybListItemBackgroundColorGradient;
  earnedAt?: string;
  row?: boolean;
  challengeId?: number | null;
  challengeName?: string;
  bestResultIq?: number;
  userRank?: number;
  rewardPercentage?: number;
  onClick?: () => void;
}

export interface IBybRewardListItemVariant {
  name: string;
  scarcity: RewardScarcity;
  color?: BybListItemBackgroundColorGradient;
  achieved?: boolean;
  earnedAt: string | undefined;
  handleClick?: () => void;
}

const BybRewardListItem = ({
  id,
  name,
  goal,
  scarcity = RewardScarcity.COMMON,
  color,
  earnedAt,
  row = false,
  challengeId,
  onClick,
}: IBybRewardListItem) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleClick = () => {
    onClick?.();
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <Box position={"relative"}>
        {!row ? (
          <BybRewardListItemRegular
            name={name}
            scarcity={scarcity}
            color={color}
            achieved={!!earnedAt}
            earnedAt={earnedAt}
            handleClick={handleClick}
          />
        ) : (
          <BybRewardListItemCompact
            name={name}
            scarcity={scarcity}
            color={color}
            achieved={!!earnedAt}
            earnedAt={earnedAt}
            handleClick={handleClick}
          />
        )}
      </Box>
      <BybRewardDrawer
        drawerOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        rewardId={id}
        challengeId={challengeId}
        name={name}
        goal={goal}
        scarcity={scarcity}
        color={color}
        earnedAt={earnedAt}
      />
    </>
  );
};

export default BybRewardListItem;
